import React from "react";
import "./App.css";
import Welcome from "./components/Welcome";

function App() {
  return (
    <div className="App">
      <Welcome />
    </div>
  );
}

export default App;
